import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Cleave from "cleave.js/react";
//--------------------------------------------------------------------------------------------
import { states, cityStates } from "src/components/common/cityState";
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { 
    myAxios, 
    MyFormData,
    objAscSort, 
    isDevMode,
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function ContactForm({
    updateDateTime, 
    closeIt, 
    history, 
    keyword, 
    /* below for edit */
    contactHashKey, 
    firstName, 
    lastName, 
    role, 
    organizationHashKey, 
    businessPhone, 
    extension, 
    directNumber, 
    fax, 
    mobile, 
    emailValid, 
    contactEmail, 
    contactEmail2, 
    street, 
    city, 
    state, 
    postalCode, 
    country, 
    background
}){
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const contacts = useMyStore(state => state.contacts);
    const setContacts = useMyStore(state => state.setContacts);
    const organizationNames = useMyStore(state => state.organizationNames);
    const setOrganizationNames = useMyStore(state => state.setOrganizationNames);
    const contactDetails = useMyStore(state => state.contactDetails);
    const setContactDetails = useMyStore(state => state.setContactDetails);
    //--------------------------------------------------------------------------------------------
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    const path3 = decodeURIComponent(path.split("/")[3] ?? ""); // "Edit" | `organizationHashKey`
    //--------------------------------------------------------------------------------------------
    const orgHK = path3 === "Edit"?null:path3; // need to check `path3` is in `organizationHashKey`
    //--------------------------------------------------------------------------------------------
    const [curOrgKey, setCurOrgKey] = useState(orgHK ?? organizationHashKey ?? "");
    const [curStreet, setCurStreet] = useState(street);
    const [curCity, setCurCity] = useState(city);
    const [curPostalCode, setCurPostralCode] = useState(postalCode);
    const [curCountry, setCurCountry] = useState(country);
    const [email1Invalid, setEmail1Invalid] = useState({contactEmail: contactEmail});
    const [email2Invalid, setEmail2Invalid] = useState({contactEmail2: contactEmail2});
    const [curState, setCurState] = useState(state);
    //--------------------------------------------------------------------------------------------
    const handleSumbit = async e => {
        if(email1Invalid.contactEmail && email1Invalid.contactEmail !== contactEmail && email1Invalid.contactEmail !== contactEmail2){
            window.alert("Email 1 is duplicated.");
            return;
        }
        if(email2Invalid.contactEmail2 && email2Invalid.contactEmail2 !== contactEmail2 && email2Invalid.contactEmail2 !== contactEmail){
            window.alert("Email 2 is duplicated.");
            return;
        }
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        formData.append("contactHashKey", contactHashKey || "");
        const url = keyword === "Add"?"contacts/createContact.php":(keyword === "Edit"?"contacts/updateContact.php":"");
        formData.set("contactEmail", formData.get("contactEmail").toLowerCase());
        formData.set("contactEmail2", formData.get("contactEmail2").toLowerCase());
        //--------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios(url, formData);
        setShowLoader(false);
        if(!res) return;
        //--------------------------------------------------------
        if(keyword === "Add"){
            setContacts([ ...contacts.data, res.data].sort((a, b) => objAscSort(a, b, "firstName")));
            setContactDetails(contactHashKey, {...contactDetails[contactHashKey], ...res.data});
            history.push(`/${path1}/${res.data.contactHashKey}`);
        }else if(keyword === "Edit"){
            setContacts(contacts.data.map(contact => contact.contactHashKey === contactHashKey?res.data:contact));
            setContactDetails(contactHashKey, {...contactDetails[contactHashKey], ...res.data});
            history.goBack();
        }
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(updateDateTime["OrganizationNames"] === organizationNames.updatedAt) return;
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            //--------------------------------------------------------
            setShowLoader(true);
            const res1 = await myAxios("contacts/readOrgs.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res1) return;
            //--------------------------------------------------------
            setOrganizationNames(res1.data, updateDateTime["OrganizationNames"]);
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }
    }, [updateDateTime, organizationNames.updatedAt, setShowLoader, setOrganizationNames])
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {path3?() => {history.goBack()}:closeIt}
            title = {keyword}
            width = {"90rem"}
            handleFormSubmit = {handleSumbit}
            actionKey = {keyword}
        >
            <div className = "cssSeperateWhenWide pl-3 mb-3">
                <div className = "flex-grow-1 maxWidth-50 mr-3">
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "firstName" className = "font-weight-bold mb-0">First Name:</label>
                        <input
                            id = "firstName"
                            type = "text"
                            className = "form-control flex-grow-1 ml-3"
                            name = "firstName"
                            defaultValue = {firstName || ""}
                        />
                        <label htmlFor = "lastName" className = "font-weight-bold ml-3 mb-0">Last Name:</label>
                        <input
                            id = "lastName"
                            type = "text"
                            className = "form-control flex-grow-1 ml-3"
                            name = "lastName"
                            defaultValue = {lastName || ""}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "contactEmail" className = "font-weight-bold mb-0">Email 1:</label>
                        <input
                            id = "contactEmail"
                            type = "email" 
                            className = "text-lowercase form-control flex-grow-1 ml-3"
                            name = "contactEmail" 
                            defaultValue = {contactEmail || ""} 
                            onBlur = {async e => {
                                const target = e.currentTarget.value;
                                if(!target){
                                    setEmail1Invalid({});
                                    return;
                                }
                                if(target === contactEmail){
                                    setEmail1Invalid({contactEmail: contactEmail});
                                    return;
                                }
                                const formData = new MyFormData();
                                formData.append("contactHashKey", contactHashKey || "");
                                formData.append("contactEmail", target);
                                //------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("contacts/checkDuplicateContact.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //------------------------------------------------------------
                                if(res.data === ""){
                                    setEmail1Invalid({});
                                }else{
                                    setEmail1Invalid({contactHashKey: res.data.contactHashKey, contactName: [res.data.firstName, res.data.lastName].filter(name => name !== "").join(" ") || "Unknown"});
                                }
                            }}
                        />
                        <label htmlFor = "contactEmail2" className = "font-weight-bold ml-3 mb-0">Email 2:</label>
                        <input
                            id = "contactEmail2"
                            type = "email"
                            className = "text-lowercase form-control flex-grow-1 ml-3"
                            name = "contactEmail2"
                            defaultValue = {contactEmail2 || ""}
                            onBlur = {async e => {
                                const target = e.currentTarget.value;
                                if(!target){
                                    setEmail2Invalid({});
                                    return;
                                }
                                if(target === contactEmail2){
                                    setEmail2Invalid({contactEmail2: contactEmail2});
                                    return;
                                }
                                const formData = new MyFormData();
                                formData.append("contactHashKey", contactHashKey || "");
                                formData.append("contactEmail", target);
                                //------------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("contacts/checkDuplicateContact.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //------------------------------------------------------------
                                if(res.data === ""){
                                    setEmail2Invalid({});
                                }else{
                                    setEmail2Invalid({contactHashKey: res.data.contactHashKey, contactName: [res.data.firstName, res.data.lastName].filter(name => name !== "").join(" ") || "Unknown"});
                                }
                            }}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "emailValid" className = "font-weight-bold mb-0">Email 1 Valid:</label>
                        <select
                            id = "emailValid" 
                            type = "email" 
                            className = "form-control flex-grow-1 ml-3" 
                            name = "emailValid" 
                            defaultValue = {emailValid || ""}
                        >
                            <option value = "">Select</option>
                            <option>Yes</option>
                            <option>No</option>
                        </select>
                    </div>
                    {email1Invalid.contactHashKey || email2Invalid.contactHashKey?
                    <div className = "mt-2">
                        {email1Invalid.contactHashKey?
                        <div className = "font-weight-bold text-danger">
                            Email 1 has already existed in database with&nbsp;
                            <Link to = {`/${path1}/${email1Invalid.contactHashKey}`}>{email1Invalid.contactName}</Link>
                            .
                        </div>
                        :null}
                        {email2Invalid.contactHashKey?
                        <div className = "font-weight-bold text-danger">
                            Email 2 has already existed in database with&nbsp;
                            <Link to = {`/${path1}/${email2Invalid.contactHashKey}`}>{email2Invalid.contactName}</Link>
                            .
                        </div>
                        :null}
                    </div>
                    :null}
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "role" className = "font-weight-bold mb-0">Role:</label>
                        <input
                            id = "role"
                            type = "text"
                            className = "form-control flex-grow-1 ml-3"
                            name = "role"
                            defaultValue = {role || ""}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "organizationHashKey" className = "font-weight-bold mb-0">Organization:</label>
                        <select
                            id = "organizationHashKey"
                            className = "form-control flex-grow-1 ml-3"
                            name = "organizationHashKey"
                            readOnly = {orgHK}
                            value = {orgHK?orgHK:curOrgKey}
                            onChange = {e => !orgHK && setCurOrgKey(e.currentTarget.value)}
                        >
                            {!orgHK?<option value = "">Select</option>:null}
                            {organizationNames.data.map((org, orgIndex) => 
                            <option key = {orgIndex} value = {org.organizationHashKey}>
                                {org.organizationName}
                            </option>
                            )}
                        </select>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "businessPhone" className = "font-weight-bold mb-0">Business Phone:</label>
                        <Cleave
                            id = "businessPhone"
                            className = "form-control flex-grow-1 ml-3"
                            name = "businessPhone"
                            value = {businessPhone || ""}
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                            options = {{
                                
                                blocks: [3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                        <label htmlFor = "extension" className = "font-weight-bold mb-0 ml-3">Ext.:</label>
                        <input
                            id = "extension"
                            type = "text"
                            className = "form-control flex-grow-1 ml-3"
                            name = "extension"
                            defaultValue = {extension || ""}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "directNumber" className = "font-weight-bold mb-0">Direct Number:</label>
                        <Cleave
                            id = "directNumber"
                            className = "form-control flex-grow-1 ml-3"
                            name = "directNumber"
                            value = {directNumber || ""}
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"    
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "mobile" className = "font-weight-bold mb-0">Mobile:</label>
                        <Cleave
                            id = "mobile"
                            className = "form-control flex-grow-1 ml-3" name = "mobile" value = {mobile || ""}
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "fax" className = "font-weight-bold mb-0">Fax:</label>
                        <Cleave
                            id = "fax"
                            className = "form-control flex-grow-1 ml-3" name = "fax" value = {fax || ""}
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                    </div>
                </div>
                <div className = "flex-grow-1 maxWidth-50 mr-3">
                    <div className = "mt-2">
                        <button type = "button" className = "btn btn-warning" onClick = {async() => {
                            if(!curOrgKey){
                                window.alert("Select an organization first.");
                                return;
                            }
                            const formData = new MyFormData();
                            formData.append("organizationHashKey", curOrgKey);
                            //--------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios("contacts/readOrg.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //--------------------------------------------------------
                            const org = res.data;
                            setCurStreet(org.street);
                            setCurCity(org.city);
                            setCurState(org.state);
                            setCurPostralCode(org.postalCode);
                            setCurCountry(org.country);
                        }}>Copy Address from Organization</button>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "street" className = "font-weight-bold mb-0">Street:</label>
                        <input
                            id = "street"
                            type = "text"
                            className = "form-control flex-grow-1 ml-3"
                            name = "street"
                            value = {curStreet || ""}
                            onChange = {e => {
                                setCurStreet(e.currentTarget.value);
                            }}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "city" className = "font-weight-bold mb-0">City:</label>
                        <select id = "city" className = "form-control flex-grow-1 ml-3" name = "city" value = {curCity || ""}
                            onChange = {e => {
                                setCurCity(e.currentTarget.value);
                            }}
                        >
                        <option value = "">Select</option>
                        {curState?cityStates[curState].map((s, i) => <option key = {i}>{s}</option>):null}
                    </select>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "state" className = "font-weight-bold mb-0">State:</label>
                        <select id = "state" className = "form-control flex-grow-1 ml-3" name = "state" value = {curState || ""}
                            onChange = {e => {
                                setCurState(e.currentTarget.value);
                            }}
                        >
                            <option value = "">Select</option>
                            {states.map((s, i) => <option key = {i}>{s}</option>)}
                        </select>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "postalCode" className = "font-weight-bold mb-0">Postal Code:</label>
                        <input
                            id = "postalCode"
                            type = "text"
                            className = "form-control flex-grow-1 ml-3"
                            name = "postalCode"
                            value = {curPostalCode || ""}
                            onChange = {e => {
                                setCurPostralCode(e.currentTarget.value);
                            }}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "country" className = "font-weight-bold mb-0">Country:</label>
                        <input
                            autoComplete = "off"
                            id = "country"
                            type = "text"
                            className = "form-control flex-grow-1 ml-3"
                            name = "country"
                            value = {curCountry || ""}
                            list = "countries"
                            onChange = {e => {
                                setCurCountry(e.currentTarget.value);
                            }}
                        />
                        <datalist id = "countries"><option value = {"United States"}/></datalist>
                    </div>
                    <div className = "d-flex flex-column align-items-start mt-2">
                        <label htmlFor = "background" className = "font-weight-bold mb-2">Background:</label>
                        <textarea id = "background" className = "form-control w-100" rows = {3} name = "background" defaultValue = {background}/>
                    </div>
                </div>
            </div>
        </Modal>
    )
}